(function () {
  var cfg = window.SRV_CART || {};
  var THRESHOLD = cfg.threshold || 10000;
  var SYMBOL = cfg.symbol || '\u20ac';

  var busy = false; // schirmt eigene DOM-Eingriffe vom Observer ab

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + SYMBOL;
  }

  function msgFor(total) {
    return total >= THRESHOLD
      ? '<b>Gratisversand freigeschaltet.</b>'
      : 'Nur noch <b>' + money(THRESHOLD - total) + '</b> bis zum Gratisversand';
  }

  function buildShip() {
    var el = document.createElement('div');
    el.className = 'srv-ship';
    el.innerHTML =
      '<p class="srv-ship__msg"><span class="srv-ship__truck">\uD83D\uDE9A</span><span data-srv-msg></span></p>' +
      '<div class="srv-ship__track">' +
      '<div class="srv-ship__fill"></div>' +
      '<span class="srv-ship__goal"></span>' +
      '</div>';
    return el;
  }

  function syncShip(el, total) {
    var pct = Math.min(100, (total / THRESHOLD) * 100);
    var free = total >= THRESHOLD;

    if (el.dataset.srvTotal === String(total)) return; // nichts verändert
    var wasFree = el.classList.contains('is-free');
    el.dataset.srvTotal = String(total);

    el.querySelector('[data-srv-msg]').innerHTML = msgFor(total);
    el.querySelector('.srv-ship__fill').style.width = pct + '%';
    el.classList.toggle('is-free', free);

    // Lieferwagen nur beim frischen Erreichen losfahren lassen
    if (free && !wasFree) {
      var t = el.querySelector('.srv-ship__truck');
      t.style.animation = 'none';
      void t.offsetWidth;
      t.style.animation = '';
    }
  }

  function bundleHTML(cart) {
    var tpl = document.getElementById('srv-cart-bundles');
    if (!tpl) return '';

    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[String(i.product_id)] = true; });

    var pool;
    try { pool = JSON.parse(tpl.textContent || '[]'); } catch (e) { return ''; }
    pool = pool.filter(function (p) { return !inCart[String(p.id)] && p.available; });
    if (!pool.length) return '';

    var cards = pool.slice(0, 6).map(function (p) {
      var media = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy" width="132" height="176">'
        : '<span class="srv-bundle__ph">Platzhalter</span>';
      var multi = p.variants > 1;
      return (
        '<div class="srv-bundle__card">' +
        '<a class="srv-bundle__media" href="' + p.url + '">' + media + '</a>' +
        '<p class="srv-bundle__name">' + p.title + '</p>' +
        '<span class="srv-bundle__price">' + money(p.price) + '</span>' +
        '<button class="srv-bundle__add" type="button" data-srv-add="' + p.variant + '"' +
        (multi ? ' data-srv-url="' + p.url + '"' : '') + '>' +
        (multi ? 'Ansehen' : 'Hinzuf\u00fcgen') + '</button>' +
        '</div>'
      );
    }).join('');

    return (
      '<div class="srv-bundle" data-srv-sig="' + Object.keys(inCart).sort().join('_') + '">' +
      '<div class="srv-bundle__head">' +
      '<h3 class="srv-bundle__title">Dazu passend</h3>' +
      '<span class="srv-bundle__hint">2. Teil \u221210 %</span>' +
      '</div>' +
      '<div class="srv-bundle__rail">' + cards + '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    busy = true;

    document.querySelectorAll('.cart-drawer__inner, .cart-page-wrapper').forEach(function (root) {
      if (root.classList.contains('cart-drawer--empty') || cart.item_count === 0) {
        var s = root.querySelector('.srv-ship'); if (s) s.remove();
        var b = root.querySelector('.srv-bundle'); if (b) b.remove();
        return;
      }

      var items = root.querySelector('.cart-drawer__items') || root.querySelector('.cart-items__table');
      if (!items) return;

      // --- Versandbalken ---
      var ship = root.querySelector('.srv-ship');
      if (!ship) {
        ship = buildShip();
        items.parentNode.insertBefore(ship, items);
        // erst im nächsten Frame füllen, damit die Transition sichtbar läuft
        requestAnimationFrame(function () { syncShip(ship, cart.total_price); });
      } else {
        syncShip(ship, cart.total_price);
      }

      // --- Bundles ---
      var summary = root.querySelector('.cart-drawer__summary') || root.querySelector('.cart__summary-totals');
      if (!summary) return;

      var sig = (cart.items || []).map(function (i) { return i.product_id; }).sort().join('_');
      var existing = root.querySelector('.srv-bundle');
      if (existing && existing.dataset.srvSig === sig) return; // unverändert
      if (existing) existing.remove();

      var html = bundleHTML(cart);
      if (html) summary.insertAdjacentHTML('beforebegin', html);
    });

    requestAnimationFrame(function () { busy = false; });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-srv-add]');
    if (!btn) return;

    var url = btn.getAttribute('data-srv-url');
    if (url) { window.location.href = url; return; }

    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-srv-add')), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Im Warenkorb';
        btn.classList.add('is-done');
        return fetch('/?sections=cart-drawer-section');
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-section'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.cart-drawer__inner');
          var live = document.querySelector('.cart-drawer__inner');
          if (fresh && live) live.replaceWith(fresh);
        }
        setTimeout(refresh, 60);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  var pending = null;
  var obs = new MutationObserver(function (records) {
    if (busy) return;
    // eigene Knoten ignorieren
    var relevant = records.some(function (r) {
      return ![].some.call(r.addedNodes, function (n) {
        return n.nodeType === 1 && (n.classList.contains('srv-ship') || n.classList.contains('srv-bundle'));
      });
    });
    if (!relevant) return;
    clearTimeout(pending);
    pending = setTimeout(refresh, 180);
  });

  function boot() {
    refresh();
    obs.observe(document.body, { childList: true, subtree: true });
    ['cart:update', 'cart:refresh', 'CartUpdate'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refresh, 60); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
